import _ from 'lodash';
import { SUPPORTED_LANGUAGES } from 'arbitrip-common/translation/const';
import Config from 'arbitrip-common/client/utils/Config';

const zendeskKeyEN = process.env.REACT_APP_ZENDESK_KEY_EN;
const zendeskKeyHE = process.env.REACT_APP_ZENDESK_KEY_HE;
const zendeskKeyLetstayEN = process.env.REACT_APP_ZENDESK_KEY_LETSTAY_EN;
const zendeskKeyLetstayHE = process.env.REACT_APP_ZENDESK_KEY_LETSTAY_HE;

const toggleZendeskMessenger = (action) => {
	if (_.isFunction(window.zE)) {
		window.zE('messenger', action);
	}
};

function loadZendeskChat(profile, options) {
	const currentLanguage = options.language;

	const zendeskKey = _getZendeskKey(currentLanguage);

	const script = document.createElement('script');
	script.addEventListener('load', function () {
		if (!window.zE) return;

		// Workaround for managing widget launch button visibility in a Mobile project
		if (options.zendesk_settings?.hide_default_launcher) {
			window.zE('messenger', 'hide');

			window.zE('messenger:on', 'close', function () {
				setTimeout(() => {
					if (window.zE) {
						window.zE('messenger:set', 'zIndex', -1);
					}
				}, 500);
			});
		}

		window.zE('messenger:set', 'locale', currentLanguage);

		setTimeout(() => {
			if (window.zE) {
				_zendeskLogin(profile);
			}
		}, 1000);
	});

	script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
	script.id = 'ze-snippet';
	document.head.appendChild(script);
}

function _zendeskLogin(profile) {
	if (!window.zE) return console.error('Error loading Zendesk');

	window.zE('messenger', 'loginUser', function (callback) {
		const token = profile.settings?.zendesk_jwt_token;
		callback(token);
	});
}

function _getZendeskKey(language) {
	if (Config.is_letstay) {
		return language === SUPPORTED_LANGUAGES.HE ? zendeskKeyLetstayHE : zendeskKeyLetstayEN;
	}
	
	return language === SUPPORTED_LANGUAGES.HE ? zendeskKeyHE : zendeskKeyEN;
}

export { loadZendeskChat, toggleZendeskMessenger };
